module.exports = __webpack_public_path__ + "static/media/qrcode.8da0f1dc.jpg";